function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 1.66675C4.18409 1.66675 4.33333 1.81599 4.33333 2.00008V3.66675H12.6667C12.8508 3.66675 13 3.81599 13 4.00008V11.0001H14.6667C14.8508 11.0001 15 11.1493 15 11.3334V12.0001C15 12.1842 14.8508 12.3334 14.6667 12.3334H13V14.0001C13 14.1842 12.8508 14.3334 12.6667 14.3334H12C11.8159 14.3334 11.6667 14.1842 11.6667 14.0001V12.3334H3.33333C3.14924 12.3334 3 12.1842 3 12.0001V5.00008H1.33333C1.14924 5.00008 1 4.85084 1 4.66675V4.00008C1 3.81599 1.14924 3.66675 1.33333 3.66675H3V2.00008C3 1.81599 3.14924 1.66675 3.33333 1.66675H4ZM11.6667 5.00008H4.33333V11.0001H11.6667V5.00008Z"
});

function SvgIconCut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCut);
export default __webpack_public_path__ + "static/media/icon_cut.759edd89.svg";
export { ForwardRef as ReactComponent };